"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionCallBackEvent = void 0;
/**
 * 连接层通知接入事件名称
 *
 * @export
 * @enum {number}
 */
var ConnectionCallBackEvent;
(function (ConnectionCallBackEvent) {
    /**
     *  进入在线
     */
    ConnectionCallBackEvent["onEnterOnline"] = "OnEnterOnline";
    /**
     *  进入离线
     */
    ConnectionCallBackEvent["onEnterOffline"] = "OnEnterOffline";
    /**
     *  房间打开
     */
    ConnectionCallBackEvent["onRoomOpen"] = "OnRoomOpen";
    /**
     *  房间层断开（会继续重连, 一般是网络原因、需要延迟重试等场景）
     */
    ConnectionCallBackEvent["onRoomClose"] = "OnRoomClose";
    /**
     *  房间层关闭（不会继续重连，由于后台数据、权限变更、上层业务数据发生了异常无法继续操作，主动断开了链接）
     */
    ConnectionCallBackEvent["onRoomShutDown"] = "OnRoomShutDown";
    /**
     *  房间状态变化
     */
    ConnectionCallBackEvent["onRoomStateChange"] = "OnRoomStateChange";
    /**
     *  收到Server推送消息
     */
    ConnectionCallBackEvent["onReceiveMsgFromServer"] = "OnReceiveMsgFromServer";
    /**
     *  主动重连三次之后仍然失败
     */
    ConnectionCallBackEvent["onNetReconnectedFail"] = "OnNetReconnectedFail";
    /**
     * 心跳携带字端（不推荐使用心跳携带业务字端，仅用于特殊场景后台推送内容通过心跳返回）
     */
    ConnectionCallBackEvent["onHeartBeatCommon"] = "onHeartBeatCommon";
})(ConnectionCallBackEvent = exports.ConnectionCallBackEvent || (exports.ConnectionCallBackEvent = {}));
